import { useContext } from 'react'
import { common } from '@ocean/ui'
import InfoListLayoutContext from '../InfoListLayout/InfoListLayout.context'
import { Wrapper } from './InfoListLabel.styled'

const { Typography } = common

const InfoListLabel: React.FC = ({ children }) => {
  const { labelWidth } = useContext(InfoListLayoutContext)

  return (
    <Wrapper width={labelWidth} data-test='InfoListLabel'>
      <Typography variant='p'>{children}</Typography>
    </Wrapper>
  )
}

export default InfoListLabel
